export default "__VITE_ASSET__JgfcxmHT__"